class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.timer = this.querySelector(".announcement_timer");
    this.endDate = this.getAttribute('end-time');

    if(this.timer){
      this.run();
    }
  }

  run() {
    if(!isNaN(Date.parse(this.getOnlyDate(this.endDate)))) {
      // Update the count down every 1 second
      this.autoplay = setInterval(this.update.bind(this), 1000);
    } else {
      console.log("couldn't parse:", this.getOnlyDate(this.endDate))
    }
  }

  getOnlyDate(date) { 
    return date.split(' ').slice(0, 2).join('T');
    // return date.split(' ').join('T') + "-08:00"; // PST 
    // return date.split(' ').join('T') + "-07:00"; // PDT (Daylight savings)
  }

  addZeroBefore(number) {
    if(number < 10){
      return "0" + number
    }
    return number
  }

  getPSTNowTime() {
    const options = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
      timeZone: "America/New_York",
    };
    let localTime = new Date().getTime();
    let pstLocal = new Intl.DateTimeFormat('en-US', options).format(localTime)
    let pstLocalDate =  pstLocal.split(', ')[0] // get date
    pstLocalDate = pstLocalDate.split('/')
    pstLocalDate = pstLocalDate[2] + '-' + this.addZeroBefore(pstLocalDate[0]) + '-' + this.addZeroBefore(pstLocalDate[1]) // YYYY-MM-DD

    let pstLocalTime = pstLocal.split(', ')[1]

    let pstLocalTimeISOFormat = pstLocalDate + 'T' + pstLocalTime

    // return new Date(pstLocal).getTime()
    return new Date(pstLocalTimeISOFormat).getTime()
  }

  update() {
    const countDownDate = new Date(this.getOnlyDate(this.endDate)).getTime();

    // Get today's date and time (From PST Timezone)
    // let now = new Date().getTime();
    let now = this.getPSTNowTime();

    // Find the distance between now and the count down date
    let distance = countDownDate - now;
      
    // Time calculations for days, hours, minutes and seconds
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
    // Output the result in an element with id="demo"
    this.timer.innerHTML = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
      
    // If the count down is over, write some text 
    if (distance < 0) {
      clearInterval(this.autoplay);
      this.timer.innerHTML = "EXPIRED";
      this.style.display = "none";
    }
  }
}

customElements.define('announcement-bar', AnnouncementBar);